import { render, staticRenderFns } from "./SalesLeadOverviewPage.vue?vue&type=template&id=304e8066&scoped=true&"
import script from "./SalesLeadOverviewPage.vue?vue&type=script&lang=js&"
export * from "./SalesLeadOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeadOverviewPage.vue?vue&type=style&index=0&id=304e8066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e8066",
  null
  
)

export default component.exports